import React from "react";

export function Lines({
  leftRef,
  rightRef,
  lineWidthPx,
  color = "#6691FF",
}: {
  leftRef: React.RefObject<HTMLDivElement | null>;
  rightRef: React.RefObject<HTMLDivElement | null>;
  lineWidthPx: number;
  color?: string;
}) {
  return (
    <>
      <div
        ref={leftRef}
        className="absolute top-0 bottom-0 left-1"
        style={{ width: lineWidthPx, background: color }}
      />
      <div
        ref={rightRef}
        className="absolute top-0 bottom-0 right-1"
        style={{ width: lineWidthPx, background: color }}
      />
    </>
  );
}
